import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const home = () =>
    import ('@/page/home')
const index = () =>
    import ('@/page/index')
const resource = () =>
    import ('@/page/resource')
const comp = () =>
    import ('@/page/comp')
const appres = () =>
    import ('@/page/appres')
const download = () =>
    import ('@/page/download')
const details = () =>
    import ('@/page/details')
const examdetails = () =>
    import ('@/page/examDetails')
const questionBank = () =>
    import ('@/page/questionBank')
const space = () =>
    import ('@/page/space')
const data = () =>
    import ('@/page/bigData')
const brownDownload = () =>
    import ('@/page/brownDownload')
const testpaper = () =>
    import ('@/page/testpaper')
    // const errorpage = () =>
    //   import('@/page/errorPage/brownDownload')
export default new Router({
    // mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            component: home
        }, {
            path: '/home',
            name: 'home',
            component: home
        },
        {
            path: '/resource',
            name: 'resource',
            component: resource,
            meta: {
                ashow: false
            }
        },
        {
            path: '/comp',
            name: 'comp',
            component: comp
        },
        {
            path: '/details',
            name: 'details',
            component: details
        },
        {
            path: '/examdetails',
            name: 'examdetails',
            component: examdetails
        },

        {
            path: '/questionBank',
            name: 'questionBank',
            component: questionBank
        }, {
            path: '/space',
            name: 'space',
            component: space
        },
        {
            path: '/appres',
            name: 'appres',
            component: appres
        },

        {
            path: '/download',
            name: 'download',
            component: download
        },
        {
            path: '/big_data',
            name: 'big_data',
            component: data
        },
        {
            path: '/experience',
            name: 'experience',
            component: comp
        },
        {
            path: '/brownDownload',
            name: 'brownDownload',
            component: brownDownload
        },
        {
            path: '/testpaper',
            name: 'testpaper',
            component: testpaper
        },


    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js